<template>
  <div class="cart-page">
    <h2>我的购物车</h2>
    <div>
      <div class="back-btn">
        <button class="common-btn" @click="$router.push('/')">> 继续购物</button>
      </div>
    </div>
    <!-- <span style="position: absolute; top: 254px; z-index: 1;color: #888">全选</span> -->
    <span style="position: absolute; top: 324px; z-index: 1;color: #888">全选</span>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%;margin-left: 12px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column align="center" type="selection" width="55">
        <!-- <span>全选</span> -->
      </el-table-column>
      <el-table-column align="right" prop="name" label width="100">
        <template slot-scope="scope">
          <router-link
            v-if="scope.row.commodity"
            :to="{path:`/goodsdetail?id=${scope.row.commodity.id}&groupNo=${scope.row.commodity.groupNo||''}`}"
          >
            <img
              :src=" scope.row.commodity && scope.row.commodity.defaultImage"
              style="max-width: 100px;max-height: 60px;cursor: pointer;"
            />
          </router-link>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="commodity.name" label="商品">
        <template slot-scope="scope">
          <router-link
            v-if="scope.row.commodity"
            :to="{path:`/goodsdetail?id=${scope.row.commodity.id}&groupNo=${scope.row.commodity.groupNo||''}`}"
          >{{scope.row.commodity.name}}</router-link>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="commodity.marketPrice" label="市场价（元）" width="120"></el-table-column>
      <el-table-column align="center" prop="commodity.price" label="单价（元）" width="120"></el-table-column>
      <el-table-column align="center" prop="quantity" label="数量" width="150">
        <template slot-scope="scope">
          <el-input-number
            @change="cartEdit(scope)"
            v-model="scope.row.quantity"
            :min="1"
            size="small"
            style="width: 120px"
          ></el-input-number>
        </template>
      </el-table-column>
      <el-table-column align="center" label="小计（元）" width="150">
        <template slot-scope="scope">
          <p>{{scope.row.commodity && (scope.row.commodity.price*scope.row.quantity).toFixed(2)}}</p>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" width="150">
        <template slot-scope="scope">
          <el-popconfirm title="确认删除？" @confirm="removeCartItem(scope.row)">
            <button class="common-btn-text del" slot="reference">删除</button>
          </el-popconfirm>
          <el-popconfirm title="确认移到关注？" @confirm="moveToMyAttention(scope.row)">
            <button class="common-btn-text fouces" slot="reference">移到我的关注</button>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <div class="btn-box">
      <div class="left">
        <el-popconfirm title="确认删除？" @confirm="removeCartItems">
          <button class="common-btn-text" style="color: #000;" slot="reference">删除选中商品</button>
        </el-popconfirm>
        <el-popconfirm title="确认移到关注？" @confirm="moveToMyAttentions" style="margin: 0 8px">
          <button class="common-btn-text" style="color: rgb(131,197,136);" slot="reference">移到我的关注</button>
        </el-popconfirm>
      </div>
      <div class="right">
        <button class="common-btn sureBtn" @click="addOrder">确认订单</button>
      </div>
    </div>
    <div class="total">
      <div class="left">
        
      </div>
      <div class="right">
        <p class="money">应付总额 ￥{{totalMoney}}</p>
        <p>价格不包含增值税和运输费</p>
      </div>
    </div>
    <el-divider></el-divider>
    <div style="text-align: right">
      <button class="common-btn ppt" @click="exportPPT">生成PPT</button>
      <button class="common-btn excel" @click="exportExcel">导出Excel表格</button>
    </div>
  </div>
</template>

<script>
import {
  cartList,
  cartEdit,
  cartDelete,
  cartDeleteBatch,
  toMyAttention,
  exportExcel,
  exportPPT
} from "@/js/api";
import { toMyAttentionBatch } from "../../js/api";
export default {
  name: "cart",
  data() {
    return {
      tableData: [],
      multipleSelection: []
    };
  },
  computed: {
    totalMoney() {
      let total = 0;
      this.multipleSelection.map(z => {
        total += (z.commodity && z.commodity.price * z.quantity) || 0;
      });
      return total.toFixed(2);
    }
  },
  mounted() {
    this.getCart();
  },
  methods: {
    getCart() {
      cartList({
        userId: this.$store.state.user.info.id
      }).then(res => {
        if (res.code == 0) {
          const list = (res.result && res.result.records) || [];
          list.map(z => {
            if (z.commodity) {
              z.commodity.price = z.commodity.collectivePrice || z.commodity.marketPrice;
            }
          });
          this.tableData = list;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    removeCartItem(item) {
      console.log(999)
      cartDelete({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getCart();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    removeCartItems() {
      cartDeleteBatch({
        ids: this.multipleSelection.map(z => z.id).join(",")
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getCart();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    moveToMyAttention(item) {
      toMyAttention({
        id: item.id
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getCart();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    moveToMyAttentions() {
      toMyAttentionBatch({
        ids: this.multipleSelection.map(z => z.id).join(",")
      }).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
          this.getCart();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    exportExcel() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        return this.$message.warning("请先选择商品");
      }
      this.$prompt("请输入项目名称", "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "输入不能为空"
      })
        .then(({ value }) => {
          exportExcel({
            name: value,
            // ids: this.multipleSelection.map(z => z.commodity && z.commodity.id).join(","),
            ids: this.multipleSelection.map(z => z.id).join(","),
            userId: this.$store.state.user.info.id
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消"
          });
        });
    },
    exportPPT() {
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        return this.$message.warning("请先选择商品");
      }
      this.$prompt("请输入项目名称", "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S/,
        inputErrorMessage: "输入不能为空"
      })
        .then(({ value }) => {
          exportPPT({
            name: value,
            ids: this.multipleSelection.map(z => z.id).join(","),
            userId: this.$store.state.user.info.id
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消"
          });
        });
    },

    cartEdit(scope) {
      // this.tableData[scope.$index].quantity = scope.row.quantity;
      this.saveCart(scope.$index);
    },
    saveCart(n) {
      cartEdit(this.tableData[n]).then(res => {
        if (res.code == 200) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addOrder() {
      if (!this.$store.state.user.info.id)
        return this.$message.error("请先登录！");
      if (this.multipleSelection.length === 0)
        return this.$message.error("请先勾选商品！");
      this.$router.push(
        "/order/create?ids=" +
          JSON.stringify(this.multipleSelection.map(z => z.id))
      );
    }
  }
};
</script>

<style lang="less" scoped>
.common-btn-text{
  &.del{
    color: #000;
  }

}
.common-btn-text{
  &.fouces{
    color: rgb(131,197,136);margin-left: 8px;
  }
}
.el-button--text{color: #333;}
.money{
  color: #f00;
  &+p{color: #999;}
}
.cart-page {
  margin: auto;
  width: 1060px;
  padding: 20px 60px;
  h2 {
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: bold;
    font-family: 'fangzheng';
  }

  .back-btn {
    margin-bottom: 20px;
    padding-right: 20px;
    width: 100px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    // border-radius: 14px;
    // border: solid 1px;
    cursor: pointer;
  }
  .btn-box {
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .total {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    p {
      text-align: right;
      line-height: 1.5;
    }
    .money {
      font-weight: bold;
    }
  }
}
</style>
